import { jsonApi } from "@spree/storefront-api-v2-sdk";
import getMediaGallery from "../get-media-gallery";
import createGetAbsoluteImageUrl from "../create-get-absolute-image-url";
import { requireConfigValue } from "../../isomorphic-config";
const normalizeUser = (_spreeUserSuccessResponse, spreeUser, spreeOrderSuccessResponse, spreeOrders, token)=>{
    const placeholderImage = requireConfigValue("productPlaceholderImageUrl");
    const email = spreeUser.attributes.email;
    const ordersNumbers = spreeOrders.map((order)=>order.attributes);
    const customerToken = token.bearerToken;
    const spreeOrderLineItem = spreeOrders.map((order)=>jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, order, "line_items"));
    const spreeOrderAddress = spreeOrders.map((order)=>jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, order, "billing_address"));
    const spreeOrderVariantRecords = spreeOrders.map((order)=>jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, order, "variants"));
    const spreeOrderPayment = spreeOrders.map((order)=>jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, order, "payments"));
    const payments = spreeOrderPayment.map((payment)=>{
        const paymentAttributes = payment.map((payment)=>{
            return {
                amount: payment.attributes.amount,
                paymentMethod: payment.attributes.payment_method_name
            };
        });
        return paymentAttributes;
    });
    const spreeOrderShipment = spreeOrders.map((order)=>jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, order, "shipments"));
    const shipment = spreeOrderShipment.map((shipment)=>{
        const shipmentAttributes = shipment.map((shipment)=>{
            return shipment.attributes;
        });
        return shipmentAttributes;
    });
    const spreeOrderVariantImage = spreeOrderVariantRecords.map((spreeVariantRecords)=>{
        const spreeOrderImagesVariant = spreeVariantRecords.map((spreeVariantRecord)=>{
            const variantImages = getMediaGallery(jsonApi.findRelationshipDocuments(spreeOrderSuccessResponse, spreeVariantRecord, "images"), createGetAbsoluteImageUrl(requireConfigValue("imageHost")));
            const images = variantImages.length === 0 ? placeholderImage === false ? [] : [
                {
                    url: placeholderImage
                }
            ] : variantImages;
            return {
                images: images
            };
        });
        return spreeOrderImagesVariant;
    });
    const spreeNormalizeItems = spreeOrderLineItem.map((item, index)=>{
        const spreeOrderList = item.map((i, ind)=>{
            const spreeOrderItem = {
                ...i.attributes,
                ...spreeOrderVariantImage[index][ind]
            };
            const spreeItemAttributes = {
                ...i.attributes,
                ...spreeOrderVariantRecords[index][ind]
            };
            const spreeOrderAllItem = {
                ...spreeOrderItem,
                ...spreeItemAttributes
            };
            return spreeOrderAllItem;
        });
        return spreeOrderList;
    });
    const spreeNormalizeOrder = spreeNormalizeItems.map((item, index)=>{
        const spreeOrderAll = {
            products: item,
            orderNumber: ordersNumbers[index],
            address: spreeOrderAddress[index],
            payments: payments[index][index],
            shipment: shipment[index][index]
        };
        return spreeOrderAll;
    });
    const ordersComplete = spreeOrders;
    return {
        email,
        customerToken,
        spreeNormalizeOrder,
        ordersComplete
    };
};
export default normalizeUser;
